import React, { useState, useEffect } from 'react';
import ImageUploader from './ImageUploader';
import { Button, Toast, Modal, Form } from 'react-bootstrap';
import Accordion from 'react-bootstrap/Accordion';
import axios from 'axios';
import Carousel from 'react-bootstrap/Carousel';

const GestionViandas = () => {
    const diasSemana = ['Gorras', 'Gorros', 'Chombas', 'Remeras'];
    const [viandas, setViandas] = useState({
        Gorras: [], Gorros: [], Chombas: [], Remeras: [],
    });

    const [showToast, setShowToast] = useState(false);
    const [refresh, setRefresh] = useState(false);

    const [modalShow, setModalShow] = useState(false);
    const [selectedDay, setSelectedDay] = useState('');
    const [modalType, setModalType] = useState(''); // "add" o "edit"
    const [viandaEdit, setViandaEdit] = useState(null);

    const [newVianda, setNewVianda] = useState({
        name: '',
        description: '',
        precio: '',
        image: [], // 👈 serializamos el array
        promocion: false,
    });

    useEffect(() => {
        cargarViandas();
    }, [refresh]);

  

    const cargarViandas = () => {
        axios.get('https://pedir-imperfctt.p89nps.easypanel.host/api/viandas')
            .then(response => {
                const viandasPorDia = {};
                diasSemana.forEach(dia => {
                    viandasPorDia[dia] = response.data.filter(vianda => vianda.dia_semana === dia);
                });
                setViandas(viandasPorDia);
            })
            .catch(error => console.error("Error al cargar las viandas:", error));
    };

    // 🔥 Abrir el modal para agregar o modificar una vianda
     // 🔥 Abrir el modal para agregar o modificar una vianda
     const handleOpenModal = (dia, vianda = null) => {
        setSelectedDay(dia);
        setModalType(vianda ? 'edit' : 'add');

        if (vianda) {
            setViandaEdit(vianda);
            setNewVianda({
                name: vianda.name || '',
                description: vianda.description || '',
                precio: vianda.precio || '',
                image: vianda.image || '', // Mantener la imagen al modificar
                promocion: vianda.promocion === 'si'
            });
        } else {
            setNewVianda({ name: '', description: '', precio: '', image: [], promocion: false });
        }

        setModalShow(true);
    };
    

 // 🔥 Agregar una nueva vianda (incluye imagen)
 const agregarVianda = async () => {
    if (viandas[selectedDay].length >= 6) {
        alert("Solo se pueden agregar hasta 6 productos por categoria.");
        return;
    }

    const nuevaVianda = {
        categoryId: 1,
        name: newVianda.name,
        description: newVianda.description,
        image: JSON.stringify(newVianda.image), // ✅ acá sí lo serializás
        precio: parseFloat(newVianda.precio),
        dia_semana: selectedDay,
        promocion: newVianda.promocion ? 'si' : 'no'
    };

    try {
        const response = await axios.post('https://pedir-imperfctt.p89nps.easypanel.host/api/viandas', nuevaVianda);
        if (response.status === 201) {
            console.log("✅ Vianda agregada en el backend");

            // ✅ 1. Clonar el estado actual y agregar la vianda de manera segura
            setViandas(prev => {
                const newState = { ...prev, [selectedDay]: [...prev[selectedDay], nuevaVianda] };
                console.log("🆕 Nueva lista de viandas:", newState);
                return newState;
            });

            // ✅ 2. Forzar la recarga desde el backend después de actualizar el estado
            setTimeout(() => {
                console.log("🔄 Recargando lista de viandas desde el backend...");
                cargarViandas();
                setModalShow(false);
            }, 500); // 🔥 Se espera 500ms para que el backend guarde los datos correctamente
        }
    } catch (error) {
        console.error("❌ Error al agregar la vianda:", error);
        alert("Hubo un problema al agregar la vianda.");
    }
    setTimeout(() => {
        console.log("🔄 Recargando lista de viandas desde el backend...");
        cargarViandas();
        setModalShow(false);
    }, 300); // 🔥 Se espera 500ms para que el backend guarde los datos correctamente


    cargarViandas();
};




    // 🔥 Modificar una vianda
    const modificarVianda = async () => {
        if (!viandaEdit) return;

        const updates = [
            { field: 'name', value: newVianda.name },
            { field: 'description', value: newVianda.description },
            { field: 'precio', value: newVianda.precio },
            { field: 'promocion', value: newVianda.promocion ? 'si' : 'no' }
        ];

        try {
            for (const update of updates) {
                await axios.put(
                    `https://pedir-imperfctt.p89nps.easypanel.host/vianda/${viandaEdit.id}/${update.field}`,
                    { [update.field]: update.value }
                );
            }

            setShowToast(true);
            setRefresh(prev => !prev);
            setModalShow(false);
        } catch (error) {
            console.error("Error al modificar la vianda:", error);
            alert("Hubo un problema al modificar la vianda.");
        }
    };

    // 🔥 Eliminar una vianda
    const eliminarVianda = async (id) => {
        try {
            await axios.delete(`https://pedir-imperfctt.p89nps.easypanel.host/api/viandas/${id}`);
            setRefresh(prev => !prev);
            setShowToast(true);
        } catch (error) {
            console.error("Error al eliminar la vianda:", error);
        }
    };

    return (
        <>
            <Accordion defaultActiveKey="0">
                {diasSemana.map((dia) => (
                    <Accordion.Item eventKey={dia} key={dia}>
                        <Accordion.Header>
                            <h4>{dia} <span style={{ fontSize: '14px', color: '#888' }}>({viandas[dia].length}/6)</span></h4>
                        </Accordion.Header>
                        <Accordion.Body>
                            <Button variant="primary" size="sm" onClick={() => handleOpenModal(dia)}>
                                ➕ Agregar Producto
                            </Button>
                            <br /><br />
                            {viandas[dia].length === 0 ? (
                                <p>No hay viandas cargadas para este día.</p>
                            ) : (
                                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', gap: '10px' }}>
                                    {viandas[dia].map((vianda) => (
                                        <div key={vianda.id} style={{ border: '1px solid #ccc', padding: '10px', borderRadius: '8px', textAlign: 'center', backgroundColor: 'white' }}>
                                            <strong>{vianda.name}</strong>
                                            <br />{vianda.description}
                                            <br />Precio: ${vianda.precio}
                                            <br />Promoción: {vianda.promocion === 'si' ? '✅ Sí' : '❌ No'}
                                            <br />
                                            {/* {vianda.image && (
                                                <img src={vianda.image} alt="Vianda" style={{ width: '100px', height: '100px', objectFit: 'cover' }} />
                                            )} */}
{/*                                             {vianda.image && vianda.image.map((img, idx) => (
  <img key={idx} src={img} alt={`img-${idx}`} style={{ width: '60px', height: '60px', objectFit: 'cover', margin: '2px' }} />
))} */}



{/* 🔥 NUEVO bloque para mostrar imágenes */}
{(() => {
    let imagenes = [];

    try {
      imagenes = Array.isArray(vianda.image)
        ? vianda.image
        : vianda.image
        ? JSON.parse(vianda.image)
        : [];
    } catch (e) {
      imagenes = [];
    }

    return imagenes.map((img, idx) => (
      <img key={idx} src={img} alt={`img-${idx}`} style={{ width: '60px', height: '60px', objectFit: 'cover', margin: '2px' }} />
    ));
  })()}





                                            <br />
                                            <Button variant="danger" size="sm" onClick={() => eliminarVianda(vianda.id)}>Eliminar</Button>
                                            {' '}
                                            <Button variant="warning" size="sm" onClick={() => handleOpenModal(dia, vianda)}>Modificar</Button>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </Accordion.Body>
                    </Accordion.Item>
                ))}
            </Accordion>

              {/* ✅ Modal para agregar/modificar viandas */}
              <Modal show={modalShow} onHide={() => setModalShow(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>{modalType === 'add' ? '➕ Agregar Vianda' : '✏️ Modificar Vianda'} para {selectedDay}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group className="mb-3">
                            <Form.Label>Nombre</Form.Label>
                            <Form.Control
                                type="text"
                                value={newVianda.name}
                                onChange={(e) => setNewVianda({ ...newVianda, name: e.target.value })}
                            />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Descripción</Form.Label>
                            <Form.Control
                                as="textarea"
                                rows={2}
                                value={newVianda.description}
                                onChange={(e) => setNewVianda({ ...newVianda, description: e.target.value })}
                            />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Precio</Form.Label>
                            <Form.Control
                                type="number"
                                value={newVianda.precio}
                                onChange={(e) => setNewVianda({ ...newVianda, precio: e.target.value })}
                            />
                        </Form.Group>
                        
                        {/* 🔥 Solo mostrar el componente de imagen si estamos AGREGANDO una vianda */}
                        {modalType === 'add' && (
                            <Form.Group className="mb-3">
                                <Form.Label>Imagen</Form.Label>
                                {/* <ImageUploader onUploadComplete={(url) => setNewVianda({ ...newVianda, image: url })} /> */}
                                <ImageUploader 
                                    onUploadComplete={(url) => {
                                        setNewVianda(prev => ({ ...prev,
                                                image: [...prev.image, url]
                                                            }));
                                                                }} 
                                />

                                
                            </Form.Group>
                        )}

{modalType === 'add' && newVianda.image.length > 0 && (
  <div style={{ marginBottom: '1rem' }}>
    <Carousel interval={null}>
      {newVianda.image.map((img, idx) => (
        <Carousel.Item key={idx}>
          <img
            src={img}
            alt={`Imagen ${idx + 1}`}
            style={{ width: '100%', height: '300px', objectFit: 'contain' }}
          />
          <Carousel.Caption>
            <p style={{ backgroundColor: 'rgba(0,0,0,0.5)', borderRadius: '5px', display: 'inline-block', padding: '2px 6px' }}>
              Imagen {idx + 1} / {newVianda.image.length}
            </p>
          </Carousel.Caption>
        </Carousel.Item>
      ))}
    </Carousel>
  </div>
)}


                        <Form.Group className="mb-3">
                            <Form.Label>¿Promoción?</Form.Label>
                            <Form.Check
                                type="checkbox"
                                label="Sí"
                                checked={newVianda.promocion}
                                onChange={(e) => setNewVianda({ ...newVianda, promocion: e.target.checked })}
                            />
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setModalShow(false)}>Cancelar</Button>
                    <Button variant="success" onClick={modalType === 'add' ? agregarVianda : modificarVianda}>
                        {modalType === 'add' ? 'Guardar Vianda' : 'Guardar Cambios'}
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default GestionViandas;
